const rtf = new Intl.RelativeTimeFormat('nl', { numeric: 'auto', style: 'short' });

/** "3 min. geleden", "gisteren", or a date for older items. */
export function timeAgo(iso: string): string {
  const diff = (Date.parse(iso) - Date.now()) / 1000;
  const abs = Math.abs(diff);
  if (abs < 60) return 'nu';
  if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute');
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour');
  if (abs < 7 * 86400) return rtf.format(Math.round(diff / 86400), 'day');
  return new Date(iso).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', ...(abs > 300 * 86400 ? { year: 'numeric' } : {}) });
}
